/**
 * Centralized React Query key factory.
 * Ensures consistent cache keys and safe invalidation across the app.
 *
 * Usage:
 *   queryKey: queryKeys.designJobs.list()
 *   queryKey: queryKeys.designJobs.detail(jobId)
 *   queryClient.invalidateQueries({ queryKey: queryKeys.designJobs.all })
 */
export const queryKeys = {
  // Öffentliche Startseite: aktuelle Version von Customy Desktop
  desktopRelease: {
    all: ["desktop-release"],
  },
  // Design Generator
  designJobs: {
    all: ["design-jobs"],
    list: () => ["design-jobs"],
    detail: (jobId) => ["design-jobs", "detail", jobId],
    results: (jobId) => ["design-jobs", "results", jobId],
  },
  designCampaigns: {
    all: ["design-campaigns"],
    list: () => ["design-campaigns"],
  },
  // Eigener Präfix: Die Kennzahlen sollen nicht bei jedem Live-Event auf
  // `design-jobs` neu aggregiert werden.
  designGeneratorStats: {
    all: ["design-generator-stats"],
  },
  designGeneratorPricing: {
    all: ["design-generator-pricing"],
  },

  // Mockups
  mockups: {
    all: ["mockups"],
    list: (userId) => (userId ? ["mockups", userId] : ["mockups"]),
  },
  folders: {
    all: ["folders"],
    list: () => ["folders"],
  },
  folderGroups: {
    all: ["folderGroups"],
    list: () => ["folderGroups"],
  },

  // Design Generator niches — selten mutiert, langer staleTime
  designNiches: {
    all: ["design-niches"],
    list: () => ["design-niches"],
  },

  // Eigene Ablehngründe im Design-Review (Vorlagen je User)
  designReviewReasons: {
    all: ["design-review-reasons"],
  },

  // Master-Data (Session 21) — Products, Colors, Sizes, Materials
  masterData: {
    all: ["master-data"],
    products: {
      all: ["master-data", "products"],
      list: () => ["master-data", "products"],
      detail: (key) => ["master-data", "products", key],
      sizes: (productKey) => ["master-data", "products", productKey, "sizes"],
    },
    colors: {
      all: ["master-data", "colors"],
      list: () => ["master-data", "colors"],
    },
    materials: {
      all: ["master-data", "materials"],
      list: () => ["master-data", "materials"],
    },
    skus: {
      all: ["master-data", "skus"],
      list: (filter) => ["master-data", "skus", filter || {}],
    },
  },
};
